export function getName(key: string): string {
    return key.replace(/^.*\/([^/]+)/, "$1");
}

export function getThumbnailKey(key: string): string {
    return key.replace(/^photos\/(.*)/, "thumbnails/$1");
}
